import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { cloneDeep } from "lodash";
import { BOARDS, INACTIVE_TABLE_FILTER_BOARD_IDS } from "@Broker/@Modules/clients/board/store/board-getters";
import { mapGetters } from "vuex";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "InactiveClientsFilterDropdown",
  props: {
    value: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      selectedBoardIds: [],
      boardSearchString: ""
    };
  },
  computed: _objectSpread(_objectSpread({}, mapGetters("BoardStore", [BOARDS, INACTIVE_TABLE_FILTER_BOARD_IDS])), {}, {
    options() {
      var _context;
      if (!this.BOARDS) return [];
      let boardObj = _mapInstanceProperty(_context = this.BOARDS).call(_context, ({
        id,
        name,
        ownerDetails
      }) => {
        return {
          id,
          name,
          ownerName: `${ownerDetails.givenName} ${ownerDetails.familyName}`
        };
      });
      if (this.boardSearchString.length) {
        return _filterInstanceProperty(boardObj).call(boardObj, board => {
          var _context2;
          return _includesInstanceProperty(_context2 = board.name.toLowerCase()).call(_context2, this.boardSearchString.toLowerCase());
        });
      }
      return boardObj;
    }
  }),
  mounted() {
    this.selectedBoardIds = cloneDeep(this.INACTIVE_TABLE_FILTER_BOARD_IDS);
  },
  methods: {
    isSelected(currentId) {
      var _context3;
      return _includesInstanceProperty(_context3 = this.selectedBoardIds).call(_context3, currentId);
    },
    handleChange(event, index) {
      const selected = event.target.checked;
      const option = this.options[index];
      if (selected) {
        this.selectedBoardIds.push(option.id);
      } else {
        var _context4;
        this.selectedBoardIds = _filterInstanceProperty(_context4 = this.selectedBoardIds).call(_context4, boardId => boardId !== option.id);
      }
      this.$emit("input", [...this.selectedBoardIds]);
    }
  }
});